// Ordered dark → blue → cyan → yellow-white ramp. Fixed scale; no per-Voice autoscaling.
const stops = [[5, 9, 18], [22, 35, 95], [24, 91, 139], [36, 164, 160], [164, 210, 111], [255, 247, 186]];
export function spectrogramColor(db: number): number[] {
  const value = Math.max(0, Math.min(1, (db + 100) / 100)) * (stops.length - 1);
  const low = Math.min(stops.length - 2, Math.floor(value)), weight = value - low;
  return stops[low].map((channel, i) => Math.round(channel + (stops[low + 1][i] - channel) * weight));
}
export const dbPower = (db: number) => 10 ** (db / 10);
export const powerDb = (power: number) => Math.max(-100, Math.min(0, 10 * Math.log10(Math.max(1e-10, power))));

/** Bilinear interpolation in linear power BEFORE dB/color mapping, never RGB stretching. */
export function interpolatePower(frames: number[][], time: number, bin: number): number {
  time = Math.max(0, Math.min(frames.length - 1, time)); bin = Math.max(0, Math.min(frames[0].length - 1, bin));
  const t = Math.floor(time), b = Math.floor(bin), tx = time - t, by = bin - b;
  const next = Math.min(t + 1, frames.length - 1), upper = Math.min(b + 1, frames[0].length - 1);
  return (frames[t][b] * (1 - by) + frames[t][upper] * by) * (1 - tx)
    + (frames[next][b] * (1 - by) + frames[next][upper] * by) * tx;
}

export function spectrogramPixels(powers: number[][], width: number, height: number, lastFrame: number) {
  const rgba = new Uint8ClampedArray(width * height * 4);
  const palette = Array.from({ length: 1001 }, (_, i) => spectrogramColor(-100 + i / 10));
  for (let y = 0; y < height; y++) {
    const bin = (1 - y / Math.max(1, height - 1)) * (powers[0].length - 1);
    for (let x = 0; x < width; x++) {
      const db = powerDb(interpolatePower(powers, x / Math.max(1, width - 1) * lastFrame, bin));
      const color = palette[Math.round((db + 100) * 10)];
      const offset = (y * width + x) * 4;
      rgba[offset] = color[0]; rgba[offset + 1] = color[1]; rgba[offset + 2] = color[2]; rgba[offset + 3] = 255;
    }
  }
  return rgba;
}
